import { useMemo } from 'react';
import { SmartReportComponents } from '@/admins/SmartReports/components/Components';
import type { SmartReportPage } from '@/types/GraphqlSchema';
import type { ComponentViewProps } from '../components/Components/types';

export const useGetPageComponent = (pageData: SmartReportPage | null, slotId: string) => {
  const pageElement = pageData?.pageElements?.find(el => el.slotId === slotId) || null;

  const slotConfig = useMemo(
    () => SmartReportComponents.find(comp => comp.id === pageElement?.componentId) || null,
    [pageElement?.componentId],
  );

  return {
    pageElement,
    componentId: pageElement?.componentId || null,
    slotId,
    slotData: pageElement?.data || '',
    slotConfig,
    Component: slotConfig?.ComponentView as React.ComponentType<ComponentViewProps<unknown>>,
  };
};
